import { Outlet } from '@tanstack/react-router'
import { BottomNav, SideNav } from '@/components/molecules'

export function AppLayout() {
  return (
    <div className="mx-auto flex w-full max-w-7xl gap-12 px-4 pt-8 pb-[calc(6rem+var(--sab))] md:px-[4rem] md:pb-8">
      <aside className="sticky top-8 hidden shrink-0 self-start md:block">
        <SideNav />
      </aside>
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
      <div className="fixed inset-x-4 bottom-[calc(1rem+var(--sab))] z-(--z-bottom-nav) mx-auto max-w-76.75 md:hidden">
        <BottomNav />
      </div>
    </div>
  )
}
